<template>
  <Modal v-model="modelCreate" width="400" title="创建收藏夹">
    <div class="page-container">
      <!-- <div class="page-header">
        创建收藏夹
      </div> -->
      <div class="page-box">
        <div class="input-title">
          <span style="color:#EB5757;">*</span>收藏夹名称
        </div>
        <div class="input">
          <!-- <i class="iconfont icon-pen"></i> -->
          <input type="text" v-model="fav.name" placeholder="文件夹标题" />
        </div>
        <div class="btn-footer">
          <button class="cancel-btn" @click="cencel">取消</button>
          <button :disabled="loading" class="red-btn" @click="submit">
            {{ loading ? "创建中..." : "创建" }}
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import api from "../../../../api";
export default {
  data() {
    return {
      fav: {
        name: ""
      },
      modelCreate: false,
      loading: false
    };
  },
  methods: {
    open() {
      this.modelCreate = true;
    },
    cencel() {
      this.modelCreate = false;
      this.fav.name = "";
    },
    submit() {
      if (!this.fav.name.trim()) {
        this.$Message.warning("文件夹标题不能为空!");
        return;
      }
      this.loading = true;
      api.collections.addFavorite(this.fav).then(
        () => {
          // this.goBack();
          this.modelCreate = false;
          this.fav.name = "";
          this.$Message.success("创建成功");
          this.$emit("createSuccess");
          this.loading = false;
        },
        error => {
          this.fav.name = "";
          this.loading = false;
        }
      );
    },
    goBack() {
      this.$router.replace({ name: "widgetsBatchCollect" });
    }
  }
};
</script>
<style scoped type="text/scss" lang="scss">
.page-container {
  margin-top: -45px;
  .page-header {
    height: 90px;
    line-height: 90px;
    font-size: 24px;
    letter-spacing: 4px;
    text-align: center;
  }
  .page-box {
    .input-title {
      font-size: 16px;
      color: #313131;
      text-align: left;
    }
    .input {
      margin-top: 10px;
      //   background: #ebeff0;
      padding: 0 10px;
      border: 1px solid #999999;
      .iconfont {
        font-size: 24px;
        color: #6c6f70;
        margin-right: 10px;
        vertical-align: middle;
      }
      input {
        width: 100%;
        height: 35px;
        border: 0 none;
        background-color: transparent;
        font-size: 14px;
        &::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #6c6f70;
          font-size: 14px;
        }
        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #6c6f70;
          font-size: 14px;
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #6c6f70;
          font-size: 14px;
        }
        &:-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #6c6f70;
          font-size: 14px;
        }
      }
    }
    .btn-footer {
      text-align: right;
      margin-top: 40px;
      button {
        width: 80px;
        height: 36px;
        &:first-child {
          margin-right: 20px;
        }
        &.cancel-btn {
          background: #ffffff;
          border: 1px solid #6c6f70;
        }
      }
    }
  }
}
</style>
